export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive the package after purchasing?',
    a: 'You will receive immediate access to all the material so you can start using it right away — no waiting, no complicated steps.',
  },
  {
    q: 'What level of golf instructor is this designed for?',
    a: 'Golf Instructor Ready is designed for instructors at all experience levels — from those who are just starting to build their lesson library to experienced coaches looking for greater structure, variety and planning efficiency. The content covers beginner through advanced student levels.',
  },
  {
    q: 'Does this work for golf instructors in any country?',
    a: 'Yes. The content is designed to be universally applicable regardless of where you teach. The lessons, drills and tools work for private lessons, golf academies, resort instruction, junior programs and group clinics worldwide.',
  },
  {
    q: 'Can I edit the material?',
    a: 'The material is delivered in PDF format, ready to use as-is. You can print it, read it on any device, and refer to it before and during lessons. It is designed so that no editing is necessary — you can open it and teach directly from it.',
  },
  {
    q: 'What currency will I pay in?',
    a: 'The amount adapts automatically based on the country you are purchasing from. You pay in your local currency.',
  },
  {
    q: "What if it doesn't work for me?",
    a: 'You are fully covered by the 7-day money-back guarantee. If the material is not clear, practical or useful for your teaching, contact us within 7 days and you receive a full refund. No questions asked.',
  },
]
